<div class="modal-header py-2">
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
    <i class="fa fa-times" aria-hidden="true"></i>
  </button>
  <h6 class="modal-title w-100" id="myModalLabel">
    <i class="fad fa-lock mr-2"></i> Change Password
  </h6>
  <!-- Already Logged In Popup -->
  <h6 class="modal-title w-100 d-none" id="myModalLabel">
    <i class="fas fa-sign-in-alt mr-2"></i> Already Logged In!
  </h6>
  <!-- Video Credits Logged In Popup -->
  <h6 class="modal-title w-100 d-none" id="myModalLabel">
    <i class="fab fa-creative-commons-zero mr-2"></i> Video Credits
  </h6>
</div>
<div class="modal-body text-center">
  <div class="py-2">
    <div class="form_group mb-3">
      <label>Email ID</label>
      <div class="d-flex">
        <input type="email" id="" class="form-control" value="loremipsum@gmail.com">
      </div>
    </div>
    <div class="mb-2">
      <div class="form_group">
        <label>Mobile Number</label>
        <div class="d-flex">
          <div class="no_box">India (+91)</div>
          <input type="text" id="" class="form-control" placeholder="Enter Mobile Number">
        </div>
      </div>
    </div>
    <div class="form_group mb-3">
      <label>New Password</label>
      <div class="d-flex">
        <input type="password" id="" class="form-control" placeholder="Enter Password">
      </div>
    </div>

    <div class="form_group mb-3">
      <label>Repeat Password</label>
      <div class="d-flex">
        <input type="password" id="" class="form-control" placeholder="Enter Repeat Password">
      </div>
    </div>

    <div class="otp_box">
      <p class="register_txt mb-4" style="color: rgba(0, 0, 0, 0.5) !important;">Please type the verification code sent
        to +91 1234567894</p>
      <div class="otp d-flex">
        <input class="form-control mb-4" id="" type="password">
        <input class="form-control mb-4" id="" type="password">
        <input class="form-control mb-4" id="" type="password">
        <input class="form-control mb-4" id="" type="password">
      </div>
      <p class="register_txt mt-1" style="color: rgba(0, 0, 0, 0.5) !important;">If you didn't receive a code! <a
          class="text-black-50 f-15 text-center">Resend <i class="fad fa-sync"></i></a></p>
      <button mdbBtn type="button" color="success" size="sm" mdbWavesEffect>Send OTP on whatsapp</button>
    </div>

    <div class="err">
      <i aria-hidden="true" class="fad fa-times-circle mr-2"></i>
      Your mobile number not match, please contact support
    </div>

    <div class="success">
      <i aria-hidden="true" class="fad fa-check-circle mr-2"></i>
      Mobile verifications has successfully done.
    </div>

    <div class="btn-group d-flex justify-content-around mt-4 pl-xl-3 pl-lg-3 pl-sm-3 pl-0">
      <button class="mr-xl-3 mr-lg-3 mr-sm-3 mr-0 blue-gradient btn" gradient="blue" mdbbtn="" mdbwaveseffect=""
        style="width: 100px;">Verify OTP</button>
      <button class="mr-xl-3 mr-lg-3 mr-sm-3 mr-0 btn-danger btn" color="danger" mdbbtn="" mdbwaveseffect=""
        style="width: 100px;" tabindex="0">Cancel</button>
    </div>
  </div>

  <!-- Already Logged In Popup -->
  <div class="py2 d-none">
    <div>
      <i class="fas fa-exclamation-circle mb-3 mt-2"
        style="color: #ff3547; text-align: center; font-size: 2.5rem;"></i><br />
      This account is logged in from a different browser. Do you want to sign out on other browsers?
    </div>
    <button gradient="blue" mdbbtn="" mdbwaveseffect="" tabindex="0" class="blue-gradient btn waves-effect mt-4"
      style=" padding: 10px 30px;">Signout</button>
  </div>

  <!-- Video Credits Popup -->
  <div class="py2 d-none">
    <div class="text-left">
      You have exhausted your video count of <span style="text-decoration: underline;">Video Name</span>. However, you
      can still watch the video using Video credits.
    </div>
    <div class="form_group mb-3 mt-3" style="margin: auto; width: 50%;">
      <label>Video Credits</label>
      <div>
        <select class="browser-default custom-select mb-2">
          <option value="" disabled>Choose option</option>
          <option value="1" selected>1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
        </select>
        <p class="text-left" style="font-size: 0.85rem; color: #41b2ec;">Available Credits: 00</p>
      </div>
    </div>
    <div class="text-left">

    </div>
    <button gradient="blue" mdbbtn="" mdbwaveseffect="" tabindex="0" class="blue-gradient btn waves-effect mt-4"
      style=" padding: 10px 30px;">Redeem</button>
  </div>
</div>